// // import { Col, Form, Row, Select } from 'antd';
// // import React, { useState, useEffect } from 'react';
// // import DispatchCheckerService from '../../../services/Dispatch-Checker/DispatchCheckerService';

// // const SelectModal = ({ form }) => {
// //     const [items, setItems] = useState([]);
// //     const [lines, setLines] = useState([]);
// //     const [fetchedData, setFetchedData] = useState([]);

// //     useEffect(() => {
// //         const featchData = async () => {
// //             const getUserData = JSON.parse(localStorage.getItem('userData'));
// //             console.log(getUserData.data.su_id);

// //             const response = await DispatchCheckerService.get_userline_and_items(getUserData.data.su_id);
// //             if (Array.isArray(response)) {
// //                 setFetchedData(response);
// //                 setLines(response);
// //             } else {
// //                 console.warn("Invalid response format:", response);
// //             }
// //         };
// //         featchData();
// //     }, [])

// //     const handleLineChange = (value) => {
// //         const selectedLine = lines.find(line => line.line_no === value);
// //         setItems(selectedLine ? selectedLine.items : []);

// //         form.setFieldsValue({ line: value, item: undefined });
// //     };

// //     const handleItemChange = (value) => {
// //         form.setFieldsValue({ item: value });
// //     };


// //     return (
// //         <Form form={form} layout="vertical">
// //             {/* Line Dropdown */}
// //             <Form.Item label="Select Line" name="line">
// //                 <Select
// //                     showSearch
// //                     placeholder="Select Line"
// //                     style={{ width: "100%" }}
// //                     onChange={handleLineChange}
// //                 >
// //                     {lines.map(line => (
// //                         <Select.Option key={line.line_no} value={line.line_no}>
// //                             {line.line_no}
// //                         </Select.Option>
// //                     ))}
// //                 </Select>
// //             </Form.Item>

// //             {/* Item Dropdown */}
// //             <Form.Item label="Select Item" name="item">
// //                 <Select
// //                     showSearch
// //                     placeholder="Select an Item"
// //                     style={{ width: "100%" }}
// //                     disabled={items.length === 0}
// //                     onChange={handleItemChange}
// //                 >
// //                     {items.map(item => (
// //                         <Select.Option key={item} value={item}>
// //                             {item}
// //                         </Select.Option>
// //                     ))}
// //                 </Select>
// //             </Form.Item>
// //         </Form>
// //     );
// // };

// import { Col, Form, Row, Select } from 'antd';
// import React, { useState, useEffect } from 'react';
// import DispatchCheckerService from '../../../services/Dispatch-Checker/DispatchCheckerService';

// const SelectModal = ({ form }) => {
//     const [items, setItems] = useState([]);
//     const [lines, setLines] = useState([]);
//     const [fetchedData, setFetchedData] = useState([]);
//     const [itemDetails, setItemDetails] = useState([]);
//     const [styleNos, setStyleNos] = useState([]);
//     const [colors, setColors] = useState([]);
//     const [loading, setLoading] = useState(false);

//     useEffect(() => {
//         const fetchData = async () => {
//             setLoading(true);
//             try {
//                 const getUserData = JSON.parse(localStorage.getItem('userData'));
//                 if (!getUserData?.data?.su_id) {
//                     console.error("User data not found in localStorage");
//                     return;
//                 }
//                 console.log(getUserData.data.su_id);

//                 const response = await DispatchCheckerService.get_userline_and_items(getUserData.data.su_id);
//                 if (Array.isArray(response)) {
//                     setFetchedData(response);
//                     setLines(response);
//                 } else {
//                     console.warn("Invalid response format:", response);
//                     setLines([]);
//                 }
//             } catch (error) {
//                 console.error("Error fetching lines and items:", error);
//                 setLines([]);
//             } finally {
//                 setLoading(false);
//             }
//         };
//         fetchData();
//     }, []);

//     const handleLineChange = (value) => {
//         const selectedLine = lines.find(line => line.line_no === value);
//         setItems(selectedLine ? selectedLine.items : []);
//         setItemDetails([]);
//         setStyleNos([]);
//         setColors([]);

//         form.setFieldsValue({ line: value, item: undefined, styleNo: undefined, color: undefined });
//     };

//     const handleItemChange = async (value) => {
//         console.log("Selected Item Value:", value); // Debug log to check the value

//         form.setFieldsValue({ item: value, styleNo: undefined, color: undefined });
//         setStyleNos([]);
//         setColors([]);
//         setItemDetails([]);

//         // Stricter validation to ensure value is a non-empty string
//         if (!value || typeof value !== 'string' || value.trim() === '') {
//             console.warn("Invalid item value, skipping API call:", value);
//             return;
//         }

//         setLoading(true);
//         try {
//             const response = await DispatchCheckerService.get_item_details(value);
//             if (Array.isArray(response) && response.length > 0) {
//                 setItemDetails(response);
                
//                 // Extract unique style numbers
//                 const uniqueStyleNos = [...new Set(response.map(item => item.style_no))];
//                 setStyleNos(uniqueStyleNos);
//             } else {
//                 console.warn("No item details found or invalid response:", response);
//                 setItemDetails([]);
//             }
//         } catch (error) {
//             console.error("Error fetching item details:", error);
//             setItemDetails([]);
//         } finally {
//             setLoading(false);
//         }
//     };

//     const handleStyleNoChange = (value) => {
//         const selectedStyleItems = itemDetails.filter(item => item.style_no === value);
//         const availableColors = [...new Set(selectedStyleItems.map(item => item.color))];
//         setColors(availableColors);

//         form.setFieldsValue({ styleNo: value, color: undefined });
//     };

//     const handleColorChange = (value) => {
//         form.setFieldsValue({ color: value });
//     };

//     return (
//         <Form form={form} layout="vertical">
//             {/* Line Dropdown */}
//             <Form.Item label="Select Line" name="line">
//                 <Select
//                     showSearch
//                     placeholder="Select Line"
//                     style={{ width: "100%" }}
//                     onChange={handleLineChange}
//                     loading={loading}
//                 >
//                     {lines.map(line => (
//                         <Select.Option key={line.line_no} value={line.line_no}>
//                             {line.line_no}
//                         </Select.Option>
//                     ))}
//                 </Select>
//             </Form.Item>

//             {/* Item Dropdown */}
//             <Form.Item label="Select Item" name="item">
//                 <Select
//                     showSearch
//                     placeholder="Select an Item"
//                     style={{ width: "100%" }}
//                     disabled={items.length === 0}
//                     onChange={handleItemChange}
//                     loading={loading}
//                     allowClear // Allow clearing the selection
//                 >
//                     {items.map(item => (
//                         <Select.Option key={item} value={item}>
//                             {item}
//                         </Select.Option>
//                     ))}
//                 </Select>
//             </Form.Item>

//             {/* Style No Dropdown */}
//             <Form.Item label="Select Style No" name="styleNo">
//                 <Select
//                     showSearch
//                     placeholder="Select Style No"
//                     style={{ width: "100%" }}
//                     disabled={styleNos.length === 0}
//                     onChange={handleStyleNoChange}
//                     loading={loading}
//                 >
//                     {styleNos.map(styleNo => (
//                         <Select.Option key={styleNo} value={styleNo}>
//                             {styleNo}
//                         </Select.Option>
//                     ))}
//                 </Select>
//             </Form.Item>

//             {/* Color Dropdown */}
//             <Form.Item label="Select Color" name="color">
//                 <Select
//                     showSearch
//                     placeholder="Select Color"
//                     style={{ width: "100%" }}
//                     disabled={colors.length === 0}
//                     onChange={handleColorChange}
//                     loading={loading}
//                 >
//                     {colors.map(color => (
//                         <Select.Option key={color} value={color}>
//                             {color}
//                         </Select.Option>
//                     ))}
//                 </Select>
//             </Form.Item>
//         </Form>
//     );
// };

// export default SelectModal;
// import { Col, Form, Row, Select } from 'antd';
// import React, { useState, useEffect } from 'react';
// import DispatchCheckerService from '../../../services/Dispatch-Checker/DispatchCheckerService';

// const SelectModal = ({ form }) => {
//   const [items, setItems] = useState([]);
//   const [lines, setLines] = useState([]);
//   const [fetchedData, setFetchedData] = useState([]);
//   const [itemDetails, setItemDetails] = useState([]);
//   const [styleNos, setStyleNos] = useState([]);
//   const [colors, setColors] = useState([]);
//   const [loading, setLoading] = useState(false);

//   useEffect(() => {
//     const fetchData = async () => {
//       setLoading(true);
//       try {
//         const getUserData = JSON.parse(localStorage.getItem('userData'));
//         if (!getUserData?.data?.su_id) {
//           console.error("User data not found in localStorage");
//           return;
//         }
//         console.log(getUserData.data.su_id);

//         const response = await DispatchCheckerService.get_userline_and_items(getUserData.data.su_id);
//         if (Array.isArray(response)) {
//           setFetchedData(response);
//           setLines(response);
//         } else {
//           console.warn("Invalid response format:", response);
//           setLines([]);
//         }
//       } catch (error) {
//         console.error("Error fetching lines and items:", error);
//         setLines([]);
//       } finally {
//         setLoading(false);
//       }
//     };
//     fetchData();
//   }, []);

//   const handleLineChange = (value) => {
//     const selectedLine = lines.find(line => line.line_no === value);
//     setItems(selectedLine ? selectedLine.items : []);
//     setItemDetails([]);
//     setStyleNos([]);
//     setColors([]);

//     form.setFieldsValue({ line: value, item: undefined, styleNo: undefined, color: undefined });
//   };

//   const handleItemChange = async (value) => {
//     console.log("Selected Item Value:", value);

//     form.setFieldsValue({ item: value, styleNo: undefined, color: undefined });
//     setStyleNos([]);
//     setColors([]);
//     setItemDetails([]);

//     if (!value || typeof value !== 'string' || value.trim() === '') {
//       console.warn("Invalid item value, skipping API call:", value);
//       return;
//     }

//     setLoading(true);
//     try {
//       const response = await DispatchCheckerService.get_item_details(value);
//       if (Array.isArray(response) && response.length > 0) {
//         setItemDetails(response);
//         const uniqueStyleNos = [...new Set(response.map(item => item.style_no))];
//         setStyleNos(uniqueStyleNos);
//       } else {
//         console.warn("No item details found or invalid response:", response);
//         setItemDetails([]);
//       }
//     } catch (error) {
//       console.error("Error fetching item details:", error);
//       setItemDetails([]);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleStyleNoChange = (value) => {
//     const selectedStyleItems = itemDetails.filter(item => item.style_no === value);
//     const availableColors = [...new Set(selectedStyleItems.map(item => item.color))];
//     setColors(availableColors);

//     form.setFieldsValue({ styleNo: value, color: undefined });
//   };

//   const handleColorChange = (value) => {
//     form.setFieldsValue({ color: value });
//   };

//   return (
//     <Form form={form} layout="vertical">
//       {/* Line Dropdown */}
//       <Form.Item
//         label="Select Line"
//         name="line"
//         rules={[{ required: true, message: 'Please select a line' }]}
//       >
//         <Select
//           showSearch
//           placeholder="Select Line"
//           style={{ width: "100%" }}
//           onChange={handleLineChange}
//           loading={loading}
//         >
//           {lines.map(line => (
//             <Select.Option key={line.line_no} value={line.line_no}>
//               {line.line_no}
//             </Select.Option>
//           ))}
//         </Select>
//       </Form.Item>

//       {/* Item Dropdown */}
//       <Form.Item
//         label="Select Item"
//         name="item"
//         rules={[{ required: true, message: 'Please select an item' }]}
//       >
//         <Select
//           showSearch
//           placeholder="Select an Item"
//           style={{ width: "100%" }}
//           disabled={items.length === 0}
//           onChange={handleItemChange}
//           loading={loading}
//           allowClear
//         >
//           {items.map(item => (
//             <Select.Option key={item} value={item}>
//               {item}
//             </Select.Option>
//           ))}
//         </Select>
//       </Form.Item>

//       {/* Style No Dropdown */}
//       <Form.Item label="Select Style No" name="styleNo">
//         <Select
//           showSearch
//           placeholder="Select Style No"
//           style={{ width: "100%" }}
//           disabled={styleNos.length === 0}
//           onChange={handleStyleNoChange}
//           loading={loading}
//         >
//           {styleNos.map(styleNo => (
//             <Select.Option key={styleNo} value={styleNo}>
//               {styleNo}
//             </Select.Option>
//           ))}
//         </Select>
//       </Form.Item>

//       {/* Color Dropdown */}
//       <Form.Item label="Select Color" name="color">
//         <Select
//           showSearch
//           placeholder="Select Color"
//           style={{ width: "100%" }}
//           disabled={colors.length === 0}
//           onChange={handleColorChange}
//           loading={loading}
//         >
//           {colors.map(color => (
//             <Select.Option key={color} value={color}>
//               {color}
//             </Select.Option>
//           ))}
//         </Select>
//       </Form.Item>
//     </Form>
//   );
// };

// export default SelectModal;
import { Col,TradingView, Form, Row, Select } from 'antd';
import React, { useState, useEffect } from 'react';
import DispatchCheckerService from '../../../services/Dispatch-Checker/DispatchCheckerService';

const SelectModal = ({ form }) => {
  const [items, setItems] = useState([]);
  const [lines, setLines] = useState([]);
  const [fetchedData, setFetchedData] = useState([]);
  const [styleNos, setStyleNos] = useState([]);
  const [colors, setColors] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const getUserData = JSON.parse(localStorage.getItem('userData'));
        if (!getUserData?.data?.su_id) {
          console.error("User data not found in localStorage");
          return;
        }
        console.log(getUserData.data.su_id);

        const response = await DispatchCheckerService.get_userline_and_items(getUserData.data.su_id);
        if (response.status && Array.isArray(response.line_data)) {
          setFetchedData(response.line_data);
          setLines(response.line_data);
        } else {
          console.warn("Invalid response format:", response);
          setLines([]);
        }
      } catch (error) {
        console.error("Error fetching lines and items:", error);
        setLines([]);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  const handleLineChange = (value) => {
    const selectedLine = fetchedData.find(line => line.line_no === value);
    if (selectedLine && Array.isArray(selectedLine.items)) {
      // Extract unique items, style numbers, and colors from the selected line
      const lineItems = [...new Set(selectedLine.items.map(item => item.item_no))];
      const lineStyleNos = [...new Set(selectedLine.items.map(item => item.style_no))];
      const lineColors = [...new Set(selectedLine.items.map(item => item.color))];

      setItems(lineItems);
      setStyleNos(lineStyleNos);
      setColors(lineColors);
    } else {
      setItems([]);
      setStyleNos([]);
      setColors([]);
    }

    form.setFieldsValue({ line: value, item: undefined, styleNo: undefined, color: undefined });
  };

  const handleItemChange = (value) => {
    form.setFieldsValue({ item: value, styleNo: undefined, color: undefined });

    const selectedLine = fetchedData.find(line => line.line_no === form.getFieldValue('line'));
    if (selectedLine && value) {
      const selectedItems = selectedLine.items.filter(item => item.item_no === value);
      const uniqueStyleNos = [...new Set(selectedItems.map(item => item.style_no))];
      const uniqueColors = [...new Set(selectedItems.map(item => item.color))];

      setStyleNos(uniqueStyleNos);
      setColors(uniqueColors);
    } else {
      setStyleNos([]);
      setColors([]);
    }
  };

  const handleStyleNoChange = (value) => {
    const selectedLine = fetchedData.find(line => line.line_no === form.getFieldValue('line'));
    const selectedItem = form.getFieldValue('item');

    if (selectedLine && selectedItem) {
      const selectedStyleItems = selectedLine.items.filter(
        item => item.item_no === selectedItem && item.style_no === value
      );
      const availableColors = [...new Set(selectedStyleItems.map(item => item.color))];
      setColors(availableColors);
    } else {
      setColors([]);
    }

    form.setFieldsValue({ styleNo: value, color: undefined });
  };

  const handleColorChange = (value) => {
    form.setFieldsValue({ color: value });
  };

  return (
    <Form form={form} layout="vertical">
      {/* Line Dropdown */}
      <Form.Item
        label="Select Line"
        name="line"
        rules={[{ required: true, message: 'Please select a line' }]}
      >
        <Select
          showSearch
          placeholder="Select Line"
          style={{ width: "100%" }}
          onChange={handleLineChange}
          loading={loading}
        >
          {lines.map(line => (
            <Select.Option key={line.line_no} value={line.line_no}>
              {line.line_no}
            </Select.Option>
          ))}
        </Select>
      </Form.Item>

      {/* Item Dropdown */}
      <Form.Item
        label="Select Item"
        name="item"
        rules={[{ required: true, message: 'Please select an item' }]}
      >
        <Select
          showSearch
          placeholder="Select an Item"
          style={{ width: "100%" }}
          disabled={items.length === 0}
          onChange={handleItemChange}
          loading={loading}
          allowClear
        >
          {items.map(item => (
            <Select.Option key={item} value={item}>
              {item}
            </Select.Option>
          ))}
        </Select>
      </Form.Item>

      {/* Style No Dropdown */}
      <Form.Item 
      label="Select Style No" 
      name="styleNo"
      rules={[{ required: true, message: 'Please select an Style No' }]}>
        <Select
          showSearch
          placeholder="Select Style No"
          style={{ width: "100%" }}
          disabled={styleNos.length === 0}
          onChange={handleStyleNoChange}
          loading={loading}
        >
          {styleNos.map(styleNo => (
            <Select.Option key={styleNo} value={styleNo}>
              {styleNo}
            </Select.Option>
          ))}
        </Select>
      </Form.Item>

      {/* Color Dropdown */}
      <Form.Item 
      label="Select Color" 
      name="color"
      rules={[{ required: true, message: 'Please select an Color' }]}>
        <Select
          showSearch
          placeholder="Select Color"
          style={{ width: "100%" }}
          disabled={colors.length === 0}
          onChange={handleColorChange}
          loading={loading}
        >
          {colors.map(color => (
            <Select.Option key={color} value={color}>
              {color}
            </Select.Option>
          ))}
        </Select>
      </Form.Item>
    </Form>
  );
};

export default SelectModal;